module.exports = __webpack_public_path__ + "public/Icons/unavailableIcon.svg?77483280";